/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateSectionsControllerFindAllQueryResponse, TemplateSectionsControllerFindAllQueryParams, TemplateSectionsControllerFindAll401, TemplateSectionsControllerFindAll403 } from "../../models/checklistsController/TemplateSectionsControllerFindAll";

function getTemplateSectionsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/checklist-template-sections` as const }  
  return res
}

/**
 * @summary Get all checklist template sections
 * {@link /api/v1/checklist-template-sections}
 */
export async function templateSectionsControllerFindAll(params?: TemplateSectionsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateSectionsControllerFindAllQueryResponse, ResponseErrorConfig<TemplateSectionsControllerFindAll401 | TemplateSectionsControllerFindAll403>, unknown>({ method : "GET", url : getTemplateSectionsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}